module.exports = __webpack_public_path__ + "static/red1200-ca31365dd2bfc51d610ec1a9283193a2.png";